import PropTypes from 'prop-types';
import KitoCard from '../../../../components/DataDisplay/Card';
import KitoProgressBar from '../../../../components/DataDisplay/ProgressBar';

function AidCard({ title, description, percent, imageSrc, onClick, backgroundColor, progressLabel }) {
  return (
    <KitoCard
      key={title}
      title={title}
      subtitle={description}
      image={imageSrc}
      color={backgroundColor}
      onClick={onClick}
      fullWidth
    >
      <KitoProgressBar color={backgroundColor} current={percent} final={100} text={progressLabel || ''} />
    </KitoCard>
  );
}

export default AidCard;

AidCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  percent: PropTypes.number.isRequired,
  imageSrc: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
